import { Component, Input, OnInit } from '@angular/core';
import { MailSidenavLink } from '../../interfaces/mail-sidenav-link.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'vex-mail-sidenav-link',
    templateUrl: './mail-sidenav-link.component.html',
    styleUrls: ['./mail-sidenav-link.component.scss'],
    imports: [MatRippleModule, MatIconModule, NgIf, NgClass]
})
export class MailSidenavLinkComponent implements OnInit {
  @Input({ required: true }) link!: MailSidenavLink;
  @Input() unread = 0;
  @Input() total = 0;
  @Input() active = false;

  constructor() {}

  ngOnInit(): void {}
}
